import { Dialog } from "@themes/pollinator/ui/Dialog";
import type { MeetingParticipant } from "@platform/types/platform.types";
import { ProgramCircleParticipant } from "@platform/features/programCircle";
import { Loader } from "@themes/pollinator/ui/Loader";

export type Props = {
  participants?: MeetingParticipant[];
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
};

export function ProgramMeetingInformationDialog({
  participants,
  isLoading = false,
  isOpen = true,
  onClose,
}: Props) {
  return (
    <Dialog
      title="Cohort Participants"
      description="View your cohort members"
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="gap-0"
      className="p-0 md:p-0"
      size="4xl"
    >
      {isLoading ? (
        <Loader isAbsolute />
      ) : (
        <div className="flex flex-row flex-wrap w-full">
          {participants?.map((participant) => (
            <ProgramCircleParticipant
              key={participant.user.id}
              participant={participant.user}
              participantRole={participant.role}
              className="basis-full md:basis-1/2"
              isWithBio={false}
              isWithEditButton={false}
              isWithWebsite={false}
            />
          ))}
        </div>
      )}
    </Dialog>
  );
}

export default ProgramMeetingInformationDialog;
